// hooks/geturlstoreid.js
import { useLocation, useParams } from 'react-router-dom'

let currentStoreId = null // 🔹 shared variable

export const useStoreId = () => {
  const location = useLocation()
  const params = useParams()

  const getStoreIdFromUrl = () => {
    // Case 1: If router params provide store_id (React Router dynamic route)
    if (params?.store_id) return params.store_id

    // Case 2: Parse from pathname -> /store/{store_id}/...
    const pathParts = location.pathname.split('/').filter(Boolean)
    if (pathParts[0] === 'store' && pathParts[1]) {
      const storeIdCandidate = pathParts[1]
      if (/^[a-f0-9]{32}$/.test(storeIdCandidate)) {
        return storeIdCandidate
      }
    }
    return null
  }

  const storeId = getStoreIdFromUrl()
  currentStoreId = storeId
  return storeId
}

// 🔹 External getter (safe for non-hook usage)
export const getStoreIdValue = () => currentStoreId
